import { render, staticRenderFns } from "./SafeDigEvents.vue?vue&type=template&id=6d5b6b52&scoped=true"
import script from "./SafeDigEvents.vue?vue&type=script&lang=js"
export * from "./SafeDigEvents.vue?vue&type=script&lang=js"
import style0 from "./SafeDigEvents.vue?vue&type=style&index=0&id=6d5b6b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b6b52",
  null
  
)

export default component.exports